export function config(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
